@if (visible && eventServ.announcement; as announcement) {
  <bv-alert variant="info" class="announcement">
    <span class="announcement__text">{{ announcement.text }}</span>
    <a
      [href]="announcement.url"
      class="announcement__cta"
      rel="noopener"
      target="_blank"
      >
      {{ announcement.ctaText }} <span aria-hidden="true">&rarr;</span>
    </a>
    <button
      type="button"
      class="announcement__close"
      (click)="dismiss()"
      [attr.aria-label]="'CLOSE' | translate"
      >
      <bv-icon name="close" size="sm"></bv-icon>
    </button>
  </bv-alert>
}
